export default {
      id: "icon-apps-rows-usage",
      viewBox: "0 0 16 16",
      url: "/" + "assets/sprite.svg#icon-apps-rows",
      toString: function () {
        return this.url;
      }
    }